import { Dispatch, RefObject } from "react";
import { react } from "uikit";

import CybersourcePaymentsCurrency from "./components/CybersourcePaymentsCurrency";
import CybersourcePaymentsCountryIso from "./components/CybersourcePaymentsCountryIso";

interface Context {
	cybersourceMerchantId: string;
	cybersourceApiKeyId: string;
	cybersourceApiSecret: string;
	cybersourceApiUrl: string;
	currencyRef: RefObject<CybersourcePaymentsCurrency.Ref | null>;
	countryIsoRef: RefObject<CybersourcePaymentsCountryIso.Ref | null>;
	setCybersourceMerchantIdError: Dispatch<boolean>;
	setCybersourceApiKeyIdError: Dispatch<boolean>;
	setCybersourceApiSecretError: Dispatch<boolean>;
	setCybersourceApiUrlError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isCurrency = this.context?.currencyRef.current?.validate();
		const isCountryIso = this.context?.countryIsoRef.current?.validate();
		const isMerchantId = !!this.context?.cybersourceMerchantId.trim();
		const isApiKeyId = !!this.context?.cybersourceApiKeyId.trim();
		const isApiSecret = !!this.context?.cybersourceApiSecret.trim();
		const isApiUrl = !!this.context?.cybersourceApiUrl.trim();

		if (!isMerchantId) {
			this.context?.setCybersourceMerchantIdError(true);
		}

		if (!isApiKeyId) {
			this.context?.setCybersourceApiKeyIdError(true);
		}

		if (!isApiSecret) {
			this.context?.setCybersourceApiSecretError(true);
		}

		if (!isApiUrl) {
			this.context?.setCybersourceApiUrlError(true);
		}

		return [
			isCurrency,
			isCountryIso,
			isMerchantId,
			isApiKeyId,
			isApiSecret,
			isApiUrl,
		].every(Boolean);
	}
}
